import type { ButtonHTMLAttributes } from "react";

type Variant = "secondary" | "primary" | "ghost" | "danger";
type Size = "sm" | "md";

const BASE =
  "inline-flex items-center justify-center gap-2 rounded-[9px] font-medium transition disabled:cursor-not-allowed disabled:opacity-45 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand1/40";

const VARIANTS: Record<Variant, string> = {
  secondary: "border border-line bg-surface text-text hover:bg-soft",
  primary: "border border-fill bg-fill font-semibold text-white hover:brightness-[1.06]",
  ghost: "text-text2 hover:bg-soft",
  danger: "border border-g3 text-g3 hover:bg-g3/10",
};

const SIZES: Record<Size, string> = {
  sm: "px-[11px] py-[5px] text-[12px]",
  md: "px-3.5 py-2 text-[13px]",
};

export function Button({
  variant = "secondary",
  size = "sm",
  className = "",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: Size }) {
  return <button className={`${BASE} ${VARIANTS[variant]} ${SIZES[size]} ${className}`} {...rest} />;
}
